import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import DeviceEditDto from '../dto/DeviceEditDto';

class DeviceEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'deviceEditControl';
	}

	/**
	 * @return {Promise<DeviceEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new DeviceEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<DeviceEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new DeviceEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {DeviceEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {DeviceEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	getFormDataById(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getFormData`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} externalId
	 * @return {Promise<Object>}
	 */
	updateTechnical(externalId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/updateTechnical`, {
					externalId
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} externalId
	 * @return {Promise<boolean>}
	 */
	isOnline(externalId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/isOnline`, {
					externalId
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {boolean} accept
	 * @return {Promise<boolean>}
	 */
	changeStatus(id, accept) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/changeStatus`, {
					id,
					accept
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<boolean>}
	 */
	startStreaming(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/startStreaming`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {string} measurementName
	 * @return {Promise<Object>}
	 */
	startStreamingRecording(id, measurementName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/startStreamingRecording`, { id, measurementName })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<boolean>}
	 */
	stop(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/stop`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new DeviceEditService();
